import { render, staticRenderFns } from "./TheColorSalesCards.vue?vue&type=template&id=f37773fa&"
import script from "./TheColorSalesCards.vue?vue&type=script&lang=js&"
export * from "./TheColorSalesCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports